import { render, staticRenderFns } from "./SmallCarrousel.vue?vue&type=template&id=04b51516&"
import script from "./SmallCarrousel.vue?vue&type=script&lang=js&"
export * from "./SmallCarrousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports